<div appScrollListener [target]="'p-sidebar-content'" (scrollFired)="onScrollEvent()">
    <div class="flex-body filter-container">
        <div>
            <div class="mimic-dropdown m-r-12" *ngIf="UseProductMatrix">
                <button class="mimic-dropdown m-r-12" type="text" pButton
                    [label]="matrixPlaceHolder" icon="ei ei-caret-down" iconPos="right"
                    (click)="matrixTree.toggle($event)"></button>
            </div>
            <div *ngIf="UseProductMatrix && !selectedMatrix" class="m-t-12 align-items-center flex-body">{{'vbeiMatrixSelection' | translate}}</div>
        </div>
        <ng-container *ngIf="(UseProductMatrix && selectedMatrix) || !UseProductMatrix">
            <div class="flex-grow" [ngClass]="showAdvanceSearch ? 'show-advance-search' : 'hide-advance-search'">
                <div class="p-inputgroup p-1e align-left w-full" appClearInput (resetInput)="resetSearchText()">
                    <span class="p-inputgroup-addon"><i class="ei ei-magnifier"></i></span>
                    <input class="p-inputtext" type="text" pInputText maxlength="50"
                        placeholder="{{'vbeiFilterTests' | translate}}" [(ngModel)]="searchText"
                        (ngModelChange)="this.searchTextUpdate.next($event)">
                </div>
                <div class="advance-search-container" *ngIf="showAdvanceSearch">
                    <p-inputSwitch class="advance-search-switch" [(ngModel)]="advanceSearchEnabled"
                        (onChange)="advanceSearchCheckBoxChange()"></p-inputSwitch>
                    <a class="advance-search-toggle anchor" (click)="advanceSearch.toggle($event)">
                        <span class="title">{{advanceSearchLabels.advancedSearchLabel}}</span>
                        <i class="ei ei-caret-down"></i>
                    </a>
                </div>
            </div>
        </ng-container>
    </div>
    <p-treeTable [styleClass]="'analyes-treetable'" #tt (onNodeSelect)="onCheckboxClicked($event, true)"
        (onNodeUnselect)="onCheckboxClicked($event, false)" [value]="commercialItems" [columns]="cols"
        selectionMode="checkbox" *ngIf="(UseProductMatrix && selectedMatrix) || !UseProductMatrix"
        [(selection)]="selectedAnalysis" [globalFilterFields]="['code', 'name']">

        <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
            <tr [ttSelectableRow]="rowNode"
                *ngIf="showFavoriteItems ? rowData.isFavorite || rowData.isPartialFavorite : true"
                [ngClass]="{'structureQL': rowData.isStructuringQuotationLine}">
                <td class="no-padding">
                    <span class="align-items-center flex-body">
                        <p-treeTableToggler rowData [rowNode]="rowNode"></p-treeTableToggler>
                        <p-treeTableCheckbox #checkbox [id]="rowData.eurodatKey" class="m-r-16" *ngIf="showFavoriteItems ? rowData.isFavorite : true"
                            [value]="rowNode" [hidden]="rowData.isStructuringQuotationLine">
                        </p-treeTableCheckbox>
                        <span class="m-r-16 ci-text" [ngClass]="{'adjustWidth': !displayPrice}">
                            <b class="m-r-8" *ngIf="!rowNode.node.children && !rowData.isCustomerPackage 
                                && !rowData.isStructuringQuotationLine"
                                [innerHTML]="'[' + rowData.code + ']' | highlight: [highlightText.globalSearch]"></b>
                            <span [ngClass]="{'bold-text': rowNode.node.children}"
                                [innerHTML]="rowData.name | highlight: [highlightText.globalSearch]"></span>
                        </span>
                        <div  *ngIf="displayToolTip && showFavoriteItems ? rowData.isFavorite : true " class="m-l-auto">
                            <a 
                                (click)="onDownloadTechnicalSalesDocumentClick(rowData)" class="align-right more-info cursor" 
                                *ngIf="!rowData.isStructuringQuotationLine" pTooltip="{{'oleiDownloadTechnicalSheet' | translate}}" tooltipPosition="top" 
                                tooltipZIndex="12000" appendTo="body">
                                    <i class="ei ei-15 ei-download2"></i>
                            </a>
                            <a *ngIf="!rowData.isStructuringQuotationLine" class="align-right"
                                (mouseenter)="openToolTip(rowNode, $event, overlayReference)"><i
                                    class="ei ei-16 ei-info"></i></a>
                        </div>
                    </span>
                </td>
                <td *ngIf="enableMultiplDetermination">
                    <form novalidate [formGroup]="sampleInitForm">
                        <div class="flex-body m-b-8">
                            <div *ngIf="!rowNode.node.children
                            && !rowData.isStructuringQuotationLine" class="p-input-number" [appInputNumber]="ipt" (update)="onSampleCountUpdate($event, rowData.eurodatKey, rowNode)">
                               <input #ipt type="text" maxlength="3" (input)="oninput($event, rowData.eurodatKey, rowNode)" 
                               pKeyFilter="pint" [ngClass]="{'has-error':
                                sampleInitForm.get(rowData.eurodatKey)?.errors &&
                                (sampleInitForm.get(rowData.eurodatKey)?.dirty ||
                                sampleInitForm.get(rowData.eurodatKey)?.touched)}" 
                                onkeypress="return event.key >= '0' && event.key <= '9'"
                                formControlName={{rowData.eurodatKey}} />
                                <span class="red-text-label"  *ngIf="sampleInitForm.get(rowData.id)?.errors &&
                                (sampleInitForm.get(rowData.eurodatKey)?.dirty ||
                                sampleInitForm.get(rowData.eurodatKey)?.touched) || !sampleInitForm.get(rowData.eurodatKey)?.valid">{{maxInputErrorMessage}}</span>
                            </div>
                        </div>
                    </form>
                </td>
                <td *ngIf="displayPrice">
                    <span *ngIf="showFavoriteItems? rowData.isFavorite : true && !rowData.isStructuringQuotationLine"
                        class="price-text">{{rowData.price}}</span>
                </td>
                <td *ngIf="displayFavorite">
                    <a *ngIf="showFavoriteItems? rowData.isFavorite : true && !rowData.isStructuringQuotationLine"
                        class="cursor" (click)="onFavorite(rowNode)">
                        <i [ngClass]="{'orange': rowData.isFavorite}" class="ei ei-16 ei-star "></i>
                    </a>
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr>
                <td [ngClass]="{'isAnalysisNotExists': isAnalysisExists}" [attr.colspan]="cols?.length">{{'vbeiNoResultsFound' | translate}}</td>
            </tr>
        </ng-template>
    </p-treeTable>
</div>
<p-overlayPanel #overlayReference [showCloseIcon]="true" [appendTo]="'body'" [dismissable]="true"
    [style]="{'width': '460px'}" [baseZIndex]="950000" class="p-overlaypanel-arrow-left"
    [styleClass]="'analyses-detail overflow-overlay'">
    <div *ngIf="!toolTipData">
        <p-progressSpinner class="p-tooltip-spinner"></p-progressSpinner>
    </div>
    <div *ngIf="toolTipData">
        <dop-analyses-tool-tip [toolTipData]="toolTipData" [searchTexts]="highlightText"></dop-analyses-tool-tip>
    </div>
</p-overlayPanel>
<p-overlayPanel #advanceSearch [styleClass]="'advance-search-content'" [appendTo]="'body'" [baseZIndex]="950000">
    <ng-template pTemplate>
        <dop-advance-search [advanceSearchLabels]="advanceSearchLabels"
            [includeProperties]="advanceSearchIncludeProperties" [combineProperties]="advanceSearchCombineProperties"
            (refineSearch)="refineSearchEvent()" (clearAllFilters)="clearAllFiltersEvent()"
            (includePropertyChanged)="includePropertyChanged()"></dop-advance-search>
    </ng-template>
</p-overlayPanel>
<p-overlayPanel #matrixTree [styleClass]="'matrix-tree-content'" [appendTo]="'body'" [baseZIndex]="950000">
    <ng-template pTemplate>
        <p-tree [value]="matrices" [loading]="matrices?.length == 0" selectionMode="single"
            (onNodeSelect)="onMatrixNodeSelect($event)" [(selection)]="selectedMatrix"></p-tree>
    </ng-template>
</p-overlayPanel>